import * as React from "react";
import { createSvgIcon } from "@mui/material/utils";

export default createSvgIcon(
  <>
    <path
      className="Checkbox-focus"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16 2C19.3137 2 22 4.68629 22 8V16C22 19.3137 19.3137 22 16 22H8C4.68629 22 2 19.3137 2 16V8C2 4.68629 4.68629 2 8 2H16ZM8 4C5.79086 4 4 5.79086 4 8V16C4 18.2091 5.79086 20 8 20H16C18.2091 20 20 18.2091 20 16V8C20 5.79086 18.2091 4 16 4H8Z"
    />
    <rect x="4" y="4" width="16" height="16" rx="4" />
    <path
      d="M10.409 15.8894L7.22705 12.7075L8.64205 11.2925L10.409 13.0644L15.358 8.11047L16.773 9.52547L10.409 15.8894Z"
      fill="white"
    />
  </>,
  "AcUnit"
);
